import { SvgProps } from "../../types";

const Search3 = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={10}
    fill="none"
    {...props}>
    <path
      fill="#999B9D"
      d="M3.698 7.397c-1.033 0-1.908-.358-2.624-1.074C.358 5.607 0 4.733 0 3.698 0 2.665.358 1.79 1.074 1.074 1.79.358 2.664 0 3.698 0s1.909.358 2.625 1.074c.716.716 1.074 1.59 1.074 2.624a3.468 3.468 0 0 1-.74 2.163l3.187 3.186a.54.54 0 0 1 .156.398.54.54 0 0 1-.156.399.54.54 0 0 1-.399.156.54.54 0 0 1-.398-.156L5.86 6.657a3.468 3.468 0 0 1-2.162.74Zm0-1.138a2.47 2.47 0 0 0 1.814-.747 2.47 2.47 0 0 0 .747-1.814 2.47 2.47 0 0 0-.747-1.813 2.47 2.47 0 0 0-1.814-.747 2.47 2.47 0 0 0-1.813.747 2.47 2.47 0 0 0-.747 1.813c0 .712.249 1.316.747 1.814a2.47 2.47 0 0 0 1.813.747Z"
    />
  </svg>
);
export default Search3;
